import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentReference,
} from "@angular/fire/firestore";
import { combineLatest, forkJoin, Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import {
  User,
  Subscription,
  Roles,
  Homeowner,
  DataNotification,
} from "../../interfaces/user";
import { DevicePhone } from "../../interfaces/terminal";

import { AuthService } from "../auth/auth.service";
import { SubscriptionsService } from "../subscriptions/subscriptions.service";
import { Access } from "src/app/interfaces/access";
import { PaginationService, WhereData } from "../pagination/pagination.service";
import { CardAccess } from "src/app/interfaces/card";
import { Installation } from "src/app/interfaces/installation";
import { Ticket } from "src/app/interfaces/support";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  // private usersCollection: AngularFirestoreCollection<User>;
  public users: Observable<User[]>;
  private sellersCollection: AngularFirestoreCollection<User>;
  private sellers: Observable<User[]>;
  public usersData: User[] = [];
  public usersDataShow: User[] = [];
  public usersDataFound: User[] = [];
  public usersDataShown = 0;
  public deviceUserCollection: AngularFirestoreCollection<DevicePhone>;
  public homeownerUserCollection: AngularFirestoreCollection<Homeowner>;
  public cardsUserCollection: AngularFirestoreCollection<CardAccess>;
  public subscriptionUserCollection: AngularFirestoreCollection<Subscription>;
  public userHomeownersSelect: Homeowner[] = [];
  public userSubscriptionsSelect: Subscription[] = [];
  public accessUserCollection: AngularFirestoreCollection<Access>;
  public InstallationManagerCollection: AngularFirestoreCollection<Installation>;
  public TicketsCollection: AngularFirestoreCollection<Ticket>;
  public page = 0;

  public userRoles = {
    admin: false,
    admin_support: false,
    customer_support: false,
    contractor: false,
    manager: false,
    manager_security: false,
    seller: false,
    technical_support: false,
    parking_operator: false,
    parking_partner: false,
    sos_support: false,
    root: false,
  };
  constructor(
    private afs: AngularFirestore,
    private pagServ: PaginationService,
  ) {
    /*  this.usersCollection = this.afs.collection<User>('users',
       (ref) => {
         return ref.orderBy('created', 'asc');
       }); */
    /* this.users = this.usersCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as User;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    ); */
    /*  this.users = this.pagServ.getCollectionPaginated(
       'users', 'created', 'desc', 15, this.page, []); */
  }

  getUsers(): Observable<User[]> {
    // console.log(this.usersCollection);
    // console.log(this.users);
    return this.users;
  }

  getUser(id: string): Observable<User> {
    return this.afs.collection<User>("users").doc<User>(id).valueChanges();
  }

  getAgents(): Observable<User[]> {
    return this.afs
      .collection<User>("users", (ref) => {
        return ref.where("roles.admin", "==", true).orderBy("created", "asc");
      })
      .valueChanges();
  }

  getSalesmen(): Observable<User[]> {
    return this.afs
      .collection<User>("users", (ref) => {
        return ref.where("roles.seller", "==", true).orderBy("created", "asc");
      })
      .valueChanges();
  }

  filterUsersTest(filter: string): Observable<any[]> {
    filter = filter.toLowerCase();
    const q1 = this.afs
      .collection("users", (ref) =>
        ref
          .where("displayName", ">=", filter)
          .where("displayName", "<=", filter + "\uf8ff")
          .limit(5),
      )
      .valueChanges();
    const q2 = this.afs
      .collection("users", (ref) =>
        ref
          .where("email", ">=", filter)
          .where("email", "<=", filter + "\uf8ff")
          .limit(2),
      )
      .valueChanges();
    const q3 = this.afs
      .collection("users", (ref) =>
        ref
          .where("phoneNumber", ">=", filter)
          .where("phoneNumber", "<=", filter + "\uf8ff")
          .limit(2),
      )
      .valueChanges();
    const q4 = this.afs
      .collection("users", (ref) =>
        ref
          .where("id", ">=", filter)
          .where("id", "<=", filter + "\uf8ff")
          .limit(1),
      )
      .valueChanges();
    return combineLatest([q1, q2, q3, q4]).pipe(
      map((res) => {
        return res.reduce((acc, arr) => [...acc, ...arr], []);
      }),
    );
  }

  filterUsers(filter: string): Promise<User[]> {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      /* return this.combineData([]); */
      return this.combineData([
        this.pagServ.getCollectionPaginatedValues(
          "users",
          "created",
          "desc",
          10,
          this.page,
          [],
        ),
      ]);
    }
    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode =
      strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
    // console.log(startCode);
    // console.log(endCode);
    let whereData: WhereData = [];
    whereData.push({
      fieldPath: "displayData",
      opStr: "array-contains",
      value: filter,
    });
    const usersFilter = this.pagServ.getCollectionPaginatedValues(
      "users",
      "displayData",
      "asc",
      10,
      this.page,
      whereData,
    );
    //console.log(usersFilter);
    //return usersFilter.toPromise();
    whereData = [];
    whereData.push({ fieldPath: "email", opStr: ">=", value: filter });
    const usersEmail = this.pagServ.getCollectionPaginatedValues(
      "users",
      "email",
      "asc",
      2,
      this.page,
      whereData,
    );
    whereData = [];
    whereData.push({ fieldPath: "displayName", opStr: ">=", value: filter });
    const usersDisplayName = this.pagServ.getCollectionPaginatedValues(
      "users",
      "displayName",
      "asc",
      2,
      this.page,
      whereData,
    );
    whereData = [];
    whereData.push({ fieldPath: "phoneNumber", opStr: ">=", value: filter });
    const usersPhone = this.pagServ.getCollectionPaginatedValues(
      "users",
      "phoneNumber",
      "asc",
      2,
      this.page,
      whereData,
    );
    // console.log(whereData);

    const arraySubs = [];
    arraySubs.push(usersFilter);
    arraySubs.push(usersEmail);
    arraySubs.push(usersDisplayName);
    arraySubs.push(usersPhone);

    return this.combineData(arraySubs);

    /*  return this.pagServ.getCollectionPaginatedValues(
       'users', 'phoneNumber', 'asc', 15, 1, whereData
     ).pipe(
       map(items => items.filter(item =>
       (
         ((item.displayName + '').toLowerCase() >= startCode && (item.displayName + '').toLowerCase() <= endCode) ||
         ((item.firstName + '').toLowerCase() >= startCode && (item.firstName + '').toLowerCase() <= endCode) ||
         ((item.lastName + '').toLowerCase() >= startCode && (item.lastName).toLowerCase() <= endCode) ||
         ((item.email + '').toLowerCase() >= startCode && (item.email + '').toLowerCase() <= endCode) ||
         (item.phoneNumber >= startCode && item.phoneNumber <= endCode)
       )
       ))
     ); */
  }

  combineData(data: any[]): Promise<User[]> {
    return new Promise((resolve, reject) => {
      combineLatest(data).subscribe(
        (d) => {
          // console.log(d)
          const a = [];
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < d.length; i++) {
            a.push(d[i]);
          }
          // console.log(a);
          if (a.length === 1) {
            resolve([...a[0]]);
          } else if (a.length === 4) {
            const ids = new Set(a[0].map((d) => d.id));
            const merged = [...a[0], ...a[1].filter((d) => !ids.has(d.id))];
            const ids2 = new Set(merged.map((d2) => d2.id));
            const merged2 = [
              ...merged,
              ...a[2].filter((d2) => !ids2.has(d2.id)),
            ];
            const ids3 = new Set(merged.map((d3) => d3.id));
            const merged3 = [
              ...merged,
              ...a[3].filter((d3) => !ids3.has(d3.id)),
            ];
            resolve(merged3);
          } else {
            resolve([]);
          }
        },
        (err) => {
          reject([]);
        },
      );
    });
  }

  private sanitizeFirestoreData(value: any): any {
    if (Array.isArray(value)) {
      return value
        .map((item) => this.sanitizeFirestoreData(item))
        .filter((item) => item !== undefined);
    }

    if (value && value.constructor === Object) {
      const sanitized = {};
      Object.keys(value).forEach((key) => {
        const cleanValue = this.sanitizeFirestoreData(value[key]);
        if (cleanValue !== undefined) {
          sanitized[key] = cleanValue;
        }
      });
      return sanitized;
    }

    return value;
  }

  getDevices(userDocId: string): Observable<DevicePhone[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);
    this.deviceUserCollection = this.afs
      .collection<any>("devices")
      .doc("tokens")
      .collection<DevicePhone>("phones", (ref) => {
        return ref
          .where("userRef", "==", userRef)
          .orderBy("lastUpdate", "desc");
      });
    return this.deviceUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as DevicePhone;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getCampusDevices(userDocId: string): Observable<DevicePhone[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);
    this.deviceUserCollection = this.afs
      .collection<any>("devices")
      .doc("tokens")
      .collection<DevicePhone>("phones", (ref) => {
        return ref
          .where("user.ref", "==", userRef)
          .where("app", "==", "campus")
          .orderBy("lastUpdate", "desc");
      });
    return this.deviceUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as DevicePhone;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getSipassDevices(userDocId: string): Observable<DevicePhone[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);
    this.deviceUserCollection = this.afs
      .collection<any>("devices")
      .doc("tokens")
      .collection<DevicePhone>("phones", (ref) => {
        return ref
          .where("userRef", "==", userRef)
          .where("app", "==", "sipass")
          .orderBy("lastUpdate", "desc");
      });
    return this.deviceUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as DevicePhone;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  updateUser(u: User): Promise<void> {
    // console.log(u);
    const userRef = this.afs.firestore.collection("users").doc(u.id);
    const cleanUser = this.sanitizeFirestoreData(u);
    return userRef.update(cleanUser);
  }

  sendNotification(userID: string, notif: DataNotification): Promise<void> {
    return this.afs.firestore
      .collection("users")
      .doc(userID)
      .collection("notifications")
      .add(notif)
      .then((r) => {
        // console.log('notified!' + r.id);
      });
  }

  updateDevice(d: DevicePhone): Promise<void> {
    const deviceRef = this.afs.firestore
      .collection("devices")
      .doc("tokens")
      .collection("phones")
      .doc(d.id);
    // console.log(deviceRef);
    return deviceRef.update(d);
  }

  deleteDevice(d: DevicePhone): Promise<void> {
    const deviceRef = this.afs.firestore
      .collection("devices")
      .doc("tokens")
      .collection("phones")
      .doc(d.id);
    // console.log(deviceRef);
    return deviceRef.delete();
  }

  async deleteSubscription(sub: Subscription): Promise<void> {
    const subsRef = this.afs.firestore.collection("subscriptions").doc(sub.id);
    try {
      const doc = await subsRef.get();
      if (!doc.exists) {
        throw new Error("La suscripción no existe." + sub.id);
      }
      await subsRef.update({
        deleted: {
          ts: new Date(),
        },
      });
    } catch (error) {
      console.error("Error al eliminar la suscripción:", error);
      throw error;
    }
  }

  getHomeowners(userDocId: string): Observable<Homeowner[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);

    this.homeownerUserCollection = this.afs.collection<Homeowner>(
      "homeowners",
      (ref) => {
        return ref.where("userRef", "==", userRef);
      },
    );
    return this.homeownerUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Homeowner;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getCards(userDocId: string): Observable<CardAccess[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);

    this.cardsUserCollection = this.afs.collection<CardAccess>(
      "cards",
      (ref) => {
        return ref.where("user.ref", "==", userRef);
      },
    );
    return this.cardsUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as CardAccess;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getSubscriptions(userDocId: string): Observable<Subscription[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);

    this.subscriptionUserCollection = this.afs.collection<Subscription>(
      "subscriptions",
      (ref) => {
        return ref.where("userRef", "==", userRef).orderBy("date.final", "asc");
      },
    );
    return this.subscriptionUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Subscription;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  updateSubscription(subscription: Subscription) {
    const subscriptionQuery = this.afs.firestore
      .collection("subscriptions")
      .where("id", "==", subscription.id)
      .get()
      .then((r) => {
        // console.log(r);
        if (!r.empty) {
          // console.log(r.docs);
          if (r.docs[0].exists) {
            const subscriptionRef = this.afs.firestore
              .collection("subscriptions")
              .doc(r.docs[0].id);
            // console.log(subscriptionRef);
            subscription.id = r.docs[0].id;
            subscriptionRef.update(subscription);
          }
        }
      });
  }

  getAccess(userDocId: string): Observable<Access[]> {
    const userRef = this.afs.firestore.collection("users").doc(userDocId);

    this.accessUserCollection = this.afs.collection<Access>("access", (ref) => {
      return ref
        .where("userRef", "==", userRef)
        .limit(30)
        .orderBy("created", "desc");
      // return ref.where('userRef', '==', userRef).where('type', '==', 'self').limit(30);
    });
    return this.accessUserCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Access;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getTickets(userDocId: string): Observable<Ticket[]> {
    const userDocRef = this.afs.firestore.collection("users").doc(userDocId);
    this.TicketsCollection = this.afs.collection<Ticket>(
      "support_tickets",
      (ref) => {
        return ref
          .where("userRef", "==", userDocRef)
          .where("status", "==", "open")
          .orderBy("ts", "desc");
      },
    );
    return this.TicketsCollection.stateChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Ticket;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  getInstallationManager(userDocId: string): Observable<Installation[]> {
    const userDocRef = this.afs.firestore.collection("users").doc(userDocId);
    this.InstallationManagerCollection = this.afs.collection<Installation>(
      "installations",
      (ref) => {
        return ref
          .where("managers", "array-contains", userDocRef)
          .orderBy("name", "asc");
      },
    );
    return this.InstallationManagerCollection.stateChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Installation;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }),
    );
  }

  migrateUser(userNewAccount: User, user: User) {
    console.log(userNewAccount, user);
    return new Promise(async (resolve, reject) => {
      try {
        const userNewAccountRef = this.afs.firestore
          .collection("users")
          .doc(userNewAccount.id);
        const userRef = this.afs.firestore.collection("users").doc(user.id);

        // Obtener todas las colecciones que necesitan ser actualizadas
        const collectionsToUpdate = ["homeowners", "subscriptions"]; // Añade más colecciones si es necesario

        for (const collection of collectionsToUpdate) {
          const snapshot = await this.afs.firestore
            .collection(collection)
            .where("userRef", "==", userRef)
            .get();
          const batch = this.afs.firestore.batch();

          snapshot.forEach((doc) => {
            batch.update(doc.ref, { userRef: userNewAccountRef });
          });

          await batch.commit();
        }

        resolve("ok");
      } catch (error) {
        reject(error);
      }
    });
  }
}
